<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    width="60%"
    top="10vh"
    class="edit-detail-dialog"
    center
    @close="handleDialogClose"
    :close-on-click-modal="false">
    <span slot="title" class="title-container">
      <span class="title-text">{{factoryName + $t('factoryLabelPrint.templateContentEditing')}}</span>
      <img
        src="@/assets/close.png"
        class="close-image"
        @click="close"
      />
    </span>
    <el-form class="el-form" :model="form" ref="refForm" :rules="rules" label-width="120px">
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('common.customerName') + ':'" prop="customerName">
            {{form.customerName}}
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.productNameOrSpecification') + ':'" prop="partNo">
            <el-input
              v-model.trim="form.partNo"
              name="partNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.materialNo')" prop="materialNo">
            <el-input
              v-model.trim="form.materialNo"
              name="materialNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('common.orderNo')" prop="orderNo">
            <el-input
              v-model.trim="form.orderNo"
              name="orderNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('common.count')" prop="count">
            <el-input
              v-model.trim.number="form.count"
              name="count"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="9"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('common.weight') + ':'" prop="weight">
            <el-input
              v-model.trim="form.weight"
              name="weight"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="9"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.deliveryDate') + ':'" prop="deliveryDate">
            <el-date-picker
              v-model="form.deliveryDate"
              type="date"
              size="small"
              style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.qiangLiBatchNo') + ':'" prop="batchNo">
            <el-input
              v-model.trim="form.batchNo"
              name="batchNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('common.stylePreview') + ':'" style="margin-bottom: 0">
      </el-form-item>
      <el-form-item>
        <el-col :span="15">
          <iframe
            id="historyLabelIFrameQiangLiJuCaiDialog"
            scrolling="auto"
            width="520"
            height="260"
            frameborder="0"
            style="background: #E9E9E9;"
          ></iframe>
          <el-button style="position: absolute; margin-left: 10px;" size="small" @click="printQiangLiJuCaiLabelFrame">{{$t('common.print')}}</el-button>
        </el-col>
      </el-form-item>
    </el-form>
    <span slot="footer">
        <el-button size="small" @click="close">{{$t('common.cancel')}}</el-button>
        <el-button
          :loading="loading"
          size="small"
          type="primary"
          @click="submitForm">
            {{$t('common.sure')}}
        </el-button>
      </span>
  </el-dialog>
</template>

<script>
  import moment from 'moment';
  import {
    validateCount,
    validateWeight,
  } from '@/utils/validate';
  import {
    initQiangLiJuCaiLabelFrame,
    printFactoryLabel,
  } from '@/utils/factory-label';
  import {
    updateBox,
  } from '@/api/boxLabel';
  import {
    updateLabel,
  } from '@/api/label';

  export default {
    name: "QiangLiJuCaiLabelDialog",
    props: {
      factoryName: {
        type: String,
        default: '',
      },
      visible: {
        type: Boolean,
        default: false,
      },
      editRow: {
        type: Object,
        default: () => {},
      },
      isBoxLabel: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        form: {
          id: undefined,
          customerName: '厦门强力巨彩光电科技有限公司',
          partNo: undefined,
          materialNo: undefined,
          orderNo: undefined,
          count: undefined,
          weight: undefined,
          deliveryDate: undefined,
          batchNo: undefined,
        },
        rules: {
          customerName: [{
            required: true,
            trigger: 'blur',
            message: this.$t('validate.customerNameCanNotBeEmpty')
          }],
          partNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.productNameOrSpecificationCanNotBeEmpty')
          }],
          materialNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.materialNoCanNotBeEmpty')
          }],
          orderNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.orderNoCanNotBeEmpty')
          }],
          count: [{
            required: true,
            trigger: 'blur',
            validator: validateCount
          }],
          weight: [{
            required: true,
            trigger: 'blur',
            validator: validateWeight
          }],
          deliveryDate: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.deliveryDateCanNotBeEmpty')
          }],
          batchNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.qiangLiBatchNoCanNotBeEmpty')
          }],
        },
        loading: false,
      };
    },
    watch: {
      editRow(newValue) {
        if (newValue && Object.keys(newValue).length > 0 && this.visible === true) {
          const {
            id,
            partNo,
            customPartNo,
            purchaseOrderNo,
            qty,
            grossWeight,
            dateCode,
            trackingNo,
          } = newValue;
          this.form = {
            id,
            customerName: '厦门强力巨彩光电科技有限公司',
            partNo: partNo,
            materialNo: customPartNo,
            orderNo: purchaseOrderNo,
            count: qty,
            weight: grossWeight,
            deliveryDate: dateCode,
            batchNo: trackingNo,
          };
          setTimeout(() => {
            this.initQiangLiJuCaiLabelFrame();
          }, 500);
        }
      }
    },
    methods: {
      handleDialogClose() {
        this.close();
      },
      close() {
        this.$emit('update:visible', false);
        this.$emit('close');
        if (this.$refs.refForm && typeof this.$refs.refForm.clearValidate === 'function') {
          this.$refs.refForm.clearValidate();
        }
      },
      submitForm() {
        this.$refs.refForm.validate(async (valid) => {
          if (valid) {
            if (this.isBoxLabel) {
              this.updateBox();
            } else {
              this.updateLabel();
            }
          }
        });
      },
      async updateBox() {
        const {
          id,
          partNo,
          materialNo,
          orderNo,
          count,
          weight,
          deliveryDate,
          batchNo,
        } = this.form;
        this.loading = true;
        try {
          await updateBox({
            boxLabelId: id,
            partNo: partNo,
            customPartNo: materialNo,
            purchaseOrderNo: orderNo,
            qty: count,
            grossWeight: weight,
            dateCode: moment(deliveryDate).format('YYYY-MM-DD'),
            trackingNo: batchNo,
          });
          this.$emit('update');
          this.close();
          this.$message({
            type: 'success',
            message: this.$t('common.updateSuccess'),
          });
        } catch (e) {
          // do nothing.
        } finally {
          this.loading = false;
        }
      },
      async updateLabel() {
        const {
          id,
          partNo,
          materialNo,
          orderNo,
          count,
          weight,
          deliveryDate,
          batchNo,
        } = this.form;
        this.loading = true;
        try {
          await updateLabel({
            labelId: id,
            partNo: partNo,
            customPartNo: materialNo,
            purchaseOrderNo: orderNo,
            qty: count,
            grossWeight: weight,
            dateCode: moment(deliveryDate).format('YYYY-MM-DD'),
            trackingNo: batchNo,
          });
          this.$emit('update');
          this.close();
          this.$message({
            type: 'success',
            message: this.$t('common.updateSuccess'),
          });
        } catch (e) {
          // do nothing.
        } finally {
          this.loading = false;
        }
      },
      initQiangLiJuCaiLabelFrame() {
        const {
          partNo,
          materialNo,
          orderNo,
          count,
          weight,
          deliveryDate,
          batchNo,
        } = this.form;
        let iframe = document.getElementById('historyLabelIFrameQiangLiJuCaiDialog');
        iframe = initQiangLiJuCaiLabelFrame({
          iframe,
          partNo,
          materialNo,
          orderNo,
          count,
          weight,
          deliveryDate,
          batchNo
        });
        iframe.contentWindow.document.close();
      },
      printQiangLiJuCaiLabelFrame() {
        let iframe = document.getElementById('historyLabelIFrameQiangLiJuCaiDialog');
        printFactoryLabel(iframe);
      },
    }
  }
</script>

<style scoped>
  .title-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: space-between;
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
    padding: 10px 15px;
    align-items: center;
  }

  .title-text {
    color: #404040;
    font-size: 16px;
  }

  .el-form {
    margin: 0 30px;
  }

  .close-image {
    width: 22px;
    height: 22px;
    cursor: pointer;
    padding: 0 10px;
  }
</style>
<style>
  .edit-detail-dialog .el-dialog__header {
    padding: 0;
  }
</style>
